import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/birth-chart-calculator/page.tsx");
